import { invokeApi } from "../utils";

// Pipeline & Output
export const getPipelineMetricsApi = () =>
  invokeApi({ path: "/mainappdash/pipeline-metrics", method: "GET", isAuth: false });

export const getOutputMetricsApi = () =>
  invokeApi({ path: "/mainappdash/output-metrics", method: "GET", isAuth: false });

// Summary Section
export const getSummaryRevenueApi = () =>
  invokeApi({ path: "/mainappdash/summary/revenue", method: "GET", isAuth: false });

export const getSummaryProjectsApi = () =>
  invokeApi({ path: "/mainappdash/summary/projects", method: "GET", isAuth: false });

export const getSummaryTeamApi = () =>
  invokeApi({ path: "/mainappdash/summary/team", method: "GET", isAuth: false });

export const getSummaryQualityApi = () =>
  invokeApi({ path: "/mainappdash/summary/quality", method: "GET", isAuth: false });

export const getSummaryCustomersApi = () =>
  invokeApi({ path: "/mainappdash/summary/customers", method: "GET", isAuth: false });

export const getSummaryEfficiencyApi = () =>
  invokeApi({ path: "/mainappdash/summary/efficiency", method: "GET", isAuth: false });

// Project Success & Quality
export const getProjectSuccessRateApi = () =>
  invokeApi({ path: "/mainappdash/project-success-rate", method: "GET", isAuth: false });

export const getQualityScoreApi = () =>
  invokeApi({ path: "/mainappdash/quality-score", method: "GET", isAuth: false });

export const getDefectDensityApi = () =>
  invokeApi({ path: "/mainappdash/defect-density", method: "GET", isAuth: false });

export const getTestCoverageApi = () =>
  invokeApi({ path: "/mainappdash/test-coverage", method: "GET", isAuth: false });

export const getCodeReviewMetricsApi = () =>
  invokeApi({ path: "/mainappdash/code-review-metrics", method: "GET", isAuth: false });

export const getDeploymentFrequencyApi = () =>
  invokeApi({ path: "/mainappdash/deployment-frequency", method: "GET", isAuth: false });

// Project Success & Quality Summary
export const getQualitySummaryBugRateApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/bug-rate", method: "GET", isAuth: false });

export const getQualitySummaryPerformanceApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/performance", method: "GET", isAuth: false });

export const getQualitySummarySecurityApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/security", method: "GET", isAuth: false });

export const getQualitySummaryComplianceApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/compliance", method: "GET", isAuth: false });

export const getQualitySummaryMaintainabilityApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/maintainability", method: "GET", isAuth: false });

export const getQualitySummaryReliabilityApi = () =>
  invokeApi({ path: "/mainappdash/quality-summary/reliability", method: "GET", isAuth: false });

// Business Impact
export const getRevenueGrowthApi = () =>
  invokeApi({ path: "/mainappdash/revenue-growth", method: "GET", isAuth: false });

export const getCustomerAcquisitionApi = () =>
  invokeApi({ path: "/mainappdash/customer-acquisition", method: "GET", isAuth: false });

export const getMarketShareApi = () =>
  invokeApi({ path: "/mainappdash/market-share", method: "GET", isAuth: false });

export const getReturnOnInvestmentApi = () =>
  invokeApi({ path: "/mainappdash/return-on-investment", method: "GET", isAuth: false });

export const getCostSavingsApi = () =>
  invokeApi({ path: "/mainappdash/cost-savings", method: "GET", isAuth: false });

export const getProductivityGainsApi = () =>
  invokeApi({ path: "/mainappdash/productivity-gains", method: "GET", isAuth: false });

export const getTimeToMarketApi = () =>
  invokeApi({ path: "/mainappdash/time-to-market", method: "GET", isAuth: false });

// Business Impact Summary
export const getBusinessSummaryProfitApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/profit", method: "GET", isAuth: false });

export const getBusinessSummaryGrowthApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/growth", method: "GET", isAuth: false });

export const getBusinessSummaryEfficiencyApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/efficiency", method: "GET", isAuth: false });

export const getBusinessSummaryInnovationApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/innovation", method: "GET", isAuth: false });

export const getBusinessSummaryRiskApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/risk", method: "GET", isAuth: false });

export const getBusinessSummaryCompetitiveApi = () =>
  invokeApi({ path: "/mainappdash/business-summary/competitive", method: "GET", isAuth: false });

// Customer and Market
export const getCustomerSatisfactionApi = () =>
  invokeApi({ path: "/mainappdash/customer-satisfaction", method: "GET", isAuth: false });

export const getMarketTrendsApi = () =>
  invokeApi({ path: "/mainappdash/market-trends", method: "GET", isAuth: false });

// Customer and Market Summary
export const getCustomerSummaryRetentionApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/retention", method: "GET", isAuth: false });

export const getCustomerSummaryEngagementApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/engagement", method: "GET", isAuth: false });

export const getCustomerSummaryFeedbackApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/feedback", method: "GET", isAuth: false });

export const getCustomerSummarySupportApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/support", method: "GET", isAuth: false });

export const getCustomerSummaryLoyaltyApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/loyalty", method: "GET", isAuth: false });

export const getCustomerSummaryValueApi = () =>
  invokeApi({ path: "/mainappdash/customer-summary/value", method: "GET", isAuth: false });

// Process and Efficiency
export const getProcessOptimizationApi = () =>
  invokeApi({ path: "/mainappdash/process-optimization", method: "GET", isAuth: false });

export const getResourceUtilizationApi = () =>
  invokeApi({ path: "/mainappdash/resource-utilization", method: "GET", isAuth: false });

export const getAutomationImpactApi = () =>
  invokeApi({ path: "/mainappdash/automation-impact", method: "GET", isAuth: false });

// Process and Efficiency Summary
export const getEfficiencySummaryTimeApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/time", method: "GET", isAuth: false });

export const getEfficiencySummaryCostApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/cost", method: "GET", isAuth: false });

export const getEfficiencySummaryQualityApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/quality", method: "GET", isAuth: false });

export const getEfficiencySummaryProductivityApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/productivity", method: "GET", isAuth: false });

export const getEfficiencySummaryWasteApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/waste", method: "GET", isAuth: false });

export const getEfficiencySummaryInnovationApi = () =>
  invokeApi({ path: "/mainappdash/efficiency-summary/innovation", method: "GET", isAuth: false });

